import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import distributionApi from 'services/api/distribution';
import { actions } from 'services/store/distribution';
import { selectReleaseCoverArt } from 'services/store/distribution/selectors';
import { ReleaseFieldType } from 'services/store/distribution/types';
import { Dropzone } from './components';
import { CoverArt } from './CoverArt';

type PropsType = {
  releaseId: string;
};

export const CoverArtContainer = ({ releaseId }: PropsType) => {
  const dispatch = useDispatch();
  const [updateRelease] = distributionApi.useUpdateReleaseMutation();

  const { setCoverArtLocally } = actions;

  const currentCoverArt = useSelector(selectReleaseCoverArt(releaseId));
  const { data, loading, error } = currentCoverArt;

  const handleValidationSuccess = useCallback(
    (value: File) => {
      updateRelease({ releaseId, field: ReleaseFieldType.CoverArt, value });
    },
    [releaseId, updateRelease]
  );

  if (loading || data) {
    return (
      <CoverArt
        src={data}
        loading={loading}
        onDelete={() =>
          dispatch(setCoverArtLocally({ releaseId, imgSrc: null }))
        }
      />
    );
  }

  return <Dropzone error={error} onSuccess={handleValidationSuccess} />;
};
